export default __webpack_public_path__ + "static/Supreme-Italic-f6cba2aebbc9318ebc12bd191161f628.woff2";